import { api } from '../lib/api.js';

// דף הרכבה מודפס + קיוסק הרכבה (אלי 02/11/2026). השרת: `modules/assembly`.

export type AssemblySheetData = {
  token: string; number: string; name: string | null; client: string | null;
  devEngineer: string | null; prodEngineer: string | null;
  delivered: boolean; deliveryDate: string | null; hasImage: boolean;
};

export type AssemblyDrawing = {
  partId: string; partNumber: string; name: string | null; type: string; depth: number;
  parentNumber: string | null; quantity: number;
  sequenceIndex: number; stageName: string; departmentId: string | null;
  unitsDone: number; target: number; done: boolean;
};

export type AssemblyView = {
  projectNumber: string; projectName: string | null; drawings: AssemblyDrawing[];
  model: { url: string | null; kind: 'glb' | 'html' | null };
};

export type AssemblyState = {
  sessionId: string; employeeName: string; employeeNumber: string;
  startedAt: string; windowFrom: string; endedAt: string | null; endReason: string | null;
  stillHere: { askedAt: string; mayClose: boolean; graceSeconds: number } | null;
  marks: Array<{ partNumber: string; stageName: string; units: number; minutes: number; markedAt: string }>;
};

export type AssemblyMarkResult = {
  ok: true; marked: Array<{ partNumber: string; minutes: number; units: number; missingChildren: string | null }>;
};

const enc = encodeURIComponent;

export const assemblyApi = {
  /** המשרד (מחובר): הטוקן ונתוני הדף. */
  sheet: (projectNumber: string) => api<AssemblySheetData>(`/api/projects/${enc(projectNumber)}/assembly-sheet`),
  // הקיוסק (מפעל בלבד, אנונימי — הזהות היא התג).
  view: (token: string) => api<AssemblyView>(`/api/scan/assembly/${enc(token)}`),
  open: (token: string, employeeNumber: string) =>
    api<AssemblyState>(`/api/scan/assembly/${enc(token)}/open`, { method: 'POST', body: { employeeNumber } }),
  state: (sessionId: string, employeeNumber: string) =>
    api<AssemblyState>(`/api/scan/assembly/session/${enc(sessionId)}?employeeNumber=${enc(employeeNumber)}`),
  attend: (sessionId: string, employeeNumber: string) =>
    api<{ ok: true }>(`/api/scan/assembly/session/${enc(sessionId)}/attend`, { method: 'POST', body: { employeeNumber } }),
  mark: (sessionId: string, employeeNumber: string, partIds: string[], approvalCode?: string) =>
    api<AssemblyMarkResult>(`/api/scan/assembly/session/${enc(sessionId)}/mark`, {
      method: 'POST', body: { employeeNumber, partIds, ...(approvalCode ? { approvalCode } : {}) },
    }),
  end: (sessionId: string, employeeNumber: string, reason: 'DONE' | 'IDLE' = 'DONE') =>
    api<{ ok: true; closed: boolean }>(`/api/scan/assembly/session/${enc(sessionId)}/end`, { method: 'POST', body: { employeeNumber, reason } }),
};
